import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-performance-upgrade',
    templateUrl: './performance-upgrade.component.html',
    styleUrls: ['./performance-upgrade.component.scss'],
})
export class PerformanceUpgradeComponent implements OnInit {
    headline: string;
    shortOverview: string;
    selligPointHeader: string;
    logoPlaceholder: string;
    moduleShortDescription: string;
    backgroundColor: string;

    constructor() {}
    ngOnInit() {
        this.setUpgradePage();
    }

    setUpgradePage() {
        this.headline =
            'Rise up! The ultimate coaching resource and tool for every level of the organization';
        this.shortOverview = 'What gets measured, gets better.';
        this.selligPointHeader =
            'Visualize performance of your people and capitalize on the human potential within.';
        this.logoPlaceholder = 'src/assets/images/upgrade_thumbnails/performance_upgrade.png';
        this.moduleShortDescription =
            'Set your Key Performance Indicators and measure your producers, operations, and branches to the expectations. Who is outperforming expectations? Who needs coaching?';
        this.backgroundColor = '#ffeded';
    }
}
